import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral(['\n  padding-top: 12px;\n'], ['\n  padding-top: 12px;\n']);

import React, { PureComponent } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import AnimateHeight from 'react-animate-height';
import { Icon, DatePicker, DatePickerButton } from '../../..';
import moment from 'moment';
import { utils, translations, styles } from 'gipsy-misc';

import Field, { Close } from '../../components/Field';

var DatePickerField = function (_PureComponent) {
  _inherits(DatePickerField, _PureComponent);

  function DatePickerField() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DatePickerField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DatePickerField.__proto__ || Object.getPrototypeOf(DatePickerField)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      activeDatePicker: false
    }, _this.setActiveDatePicker = function (value) {
      _this.setState({
        activeDatePicker: value
      });
    }, _this.isSetDateButtonActive = function () {
      var value = _this.props.value;


      return value && !utils.datetime.isToday(value) && !utils.datetime.isTomorrow(value) && !utils.datetime.isOnboarding(value);
    }, _this.onChange = function (data) {
      _this.setActiveDatePicker(false);
      _this.props.onChange(data);
    }, _this.deactivateField = function (e) {
      var id = _this.props.id;

      _this.props.deactivateField && _this.props.deactivateField(e, id);
      _this.props.onChange({ paramName: id, value: '' });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DatePickerField, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          mode = _props.mode,
          className = _props.className,
          children = _props.children,
          label = _props.label,
          icon = _props.icon,
          id = _props.id,
          isActive = _props.isActive,
          isOpen = _props.isOpen,
          toggleField = _props.toggleField,
          value = _props.value,
          pinTime = _props.pinTime,
          noPadding = _props.noPadding,
          backgroundHover = _props.backgroundHover,
          showClose = _props.showClose,
          hideBacklog = _props.hideBacklog;
      var activeDatePicker = this.state.activeDatePicker;

      var backlogValue = hideBacklog || value ? value : translations.general.backlog;
      var displayValue = utils.datetime.isValid(value) ? utils.datetime.humanizeDateTime(value, pinTime) : backlogValue;

      var datePickerValue = utils.datetime.isOnboarding(value) ? '' : value;

      return React.createElement(
        Field,
        {
          onClick: utils.DOM.stopPropagation,
          backgroundHover: backgroundHover,
          noPadding: noPadding,
          className: 'date-field' + (className ? ' ' + className : '') + (isActive ? ' active' : '') + (isOpen ? ' open' : '') },
        React.createElement(
          'div',
          { className: 'row click-field gp-layout gp-row gp-space-between', onClick: function onClick(e) {
              return toggleField(e, id);
            } },
          React.createElement(
            'div',
            { className: 'field-label' },
            React.createElement(Icon, { className: 'label-icon', icon: icon }),
            React.createElement(
              'span',
              { className: 'label-text' },
              label
            )
          ),
          displayValue && React.createElement(
            'div',
            { className: 'value' },
            displayValue
          )
        ),
        mode !== 'preview' && React.createElement(
          'div',
          { className: 'row open-row' },
          React.createElement(
            AnimateHeight,
            { duration: 300, height: isOpen ? 'auto' : 0 },
            React.createElement(
              DatePickerButtonContainer,
              { className: 'gp-layout gp-row gp-flex-center mgb10' },
              React.createElement(
                DatePickerButton,
                {
                  onClick: function onClick() {
                    return _this2.onChange({
                      paramName: id,
                      value: moment().format('YYYY-MM-DD')
                    });
                  },
                  textColor: utils.datetime.isToday(value) ? 'white' : styles.colors.textLightColor,
                  backgroundColor: utils.datetime.isToday(value) ? styles.colors.darkGrey : styles.colors.lightGrey,
                  style: { marginLeft: 0 } },
                utils.string.capitalize(translations.general.today)
              ),
              React.createElement(
                DatePickerButton,
                {
                  onClick: function onClick() {
                    return _this2.onChange({
                      paramName: id,
                      value: moment().add(1, 'days').format('YYYY-MM-DD')
                    });
                  },
                  textColor: utils.datetime.isTomorrow(value) ? 'white' : styles.colors.textLightColor,
                  backgroundColor: utils.datetime.isTomorrow(value) ? styles.colors.darkGrey : styles.colors.lightGrey,
                  style: { marginRight: 0 } },
                utils.string.capitalize(translations.general.tomorrow)
              ),
              React.createElement(
                DatePickerButton,
                {
                  onClick: function onClick() {
                    return _this2.setActiveDatePicker(!activeDatePicker);
                  },
                  textColor: this.isSetDateButtonActive() || activeDatePicker ? 'white' : styles.colors.textLightColor,
                  backgroundColor: this.isSetDateButtonActive() || activeDatePicker ? styles.colors.darkGrey : styles.colors.lightGrey,
                  style: { marginLeft: 0 } },
                this.isSetDateButtonActive() ? utils.datetime.beautifyDate(value) : '\n                  ' + utils.string.capitalize(translations.general.setDate)
              ),
              !hideBacklog && React.createElement(
                DatePickerButton,
                {
                  onClick: function onClick() {
                    return _this2.onChange({
                      paramName: id,
                      value: ''
                    });
                  },
                  textColor: !value ? 'white' : styles.colors.textLightColor,
                  backgroundColor: !value ? styles.colors.darkGrey : styles.colors.lightGrey,
                  style: { marginRight: 0 } },
                utils.string.capitalize(translations.general.backlog)
              )
            ),
            React.createElement(DatePicker, {
              className: activeDatePicker ? 'active' : '',
              paramName: id,
              selectedDay: datePickerValue,
              onChange: this.onChange
            }),
            children ? children : ''
          )
        ),
        showClose && React.createElement(Close, { onClick: this.deactivateField })
      );
    }
  }]);

  return DatePickerField;
}(PureComponent);

DatePickerField.propTypes = {
  mode: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.array,
  label: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  id: PropTypes.string,
  isActive: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  deactivateField: PropTypes.func,
  toggleField: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  pinTime: PropTypes.string,
  noPadding: PropTypes.bool,
  backgroundHover: PropTypes.string,
  showClose: PropTypes.bool,
  hideBacklog: PropTypes.bool
};
DatePickerField.defaultProps = {
  showClose: true
};


var DatePickerButtonContainer = styled.div(_templateObject);

export default DatePickerField;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/fields/DatePicker/index.js
// module id = 487
// module chunks = 0